import { serializeConstant } from "./constant";
export var RegisterId;
(function (RegisterId) {
    RegisterId["R4"] = "R4";
    RegisterId["R5"] = "R5";
    RegisterId["R6"] = "R6";
    RegisterId["R7"] = "R7";
    RegisterId["R8"] = "R8";
    RegisterId["R9"] = "R9";
})(RegisterId || (RegisterId = {}));
export function parseRegisterId(s) {
    switch (s) {
        case "R4":
            return RegisterId.R4;
        case "R5":
            return RegisterId.R5;
        case "R6":
            return RegisterId.R6;
        case "R7":
            return RegisterId.R7;
        case "R8":
            return RegisterId.R8;
        case "R9":
            return RegisterId.R9;
    }
    return undefined;
}
export const EmptyRegisters = {};
export function registers(regs) {
    let acc = EmptyRegisters;
    for (let [id, value] of regs)
        acc[id] = serializeConstant(value);
    return acc;
}
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoicmVnaXN0ZXJzLmpzIiwic291cmNlUm9vdCI6IiIsInNvdXJjZXMiOlsiLi4vLi4vLi4vLi4vc3JjL2VyZ28vZW50aXRpZXMvcmVnaXN0ZXJzLnRzIl0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiJBQUFBLE9BQU8sRUFBVyxpQkFBaUIsRUFBQyxNQUFNLFlBQVksQ0FBQTtBQUd0RCxNQUFNLENBQU4sSUFBWSxVQU9YO0FBUEQsV0FBWSxVQUFVO0lBQ3BCLHVCQUFTLENBQUE7SUFDVCx1QkFBUyxDQUFBO0lBQ1QsdUJBQVMsQ0FBQTtJQUNULHVCQUFTLENBQUE7SUFDVCx1QkFBUyxDQUFBO0lBQ1QsdUJBQVMsQ0FBQTtBQUNYLENBQUMsRUFQVyxVQUFVLEtBQVYsVUFBVSxRQU9yQjtBQUVELE1BQU0sVUFBVSxlQUFlLENBQUMsQ0FBUztJQUN2QyxRQUFRLENBQUMsRUFBRTtRQUNULEtBQUssSUFBSTtZQUNQLE9BQU8sVUFBVSxDQUFDLEVBQUUsQ0FBQTtRQUN0QixLQUFLLElBQUk7WUFDUCxPQUFPLFVBQVUsQ0FBQyxFQUFFLENBQUE7UUFDdEIsS0FBSyxJQUFJO1lBQ1AsT0FBTyxVQUFVLENBQUMsRUFBRSxDQUFBO1FBQ3RCLEtBQUssSUFBSTtZQUNQLE9BQU8sVUFBVSxDQUFDLEVBQUUsQ0FBQTtRQUN0QixLQUFLLElBQUk7WUFDUCxPQUFPLFVBQVUsQ0FBQyxFQUFFLENBQUE7UUFDdEIsS0FBSyxJQUFJO1lBQ1AsT0FBTyxVQUFVLENBQUMsRUFBRSxDQUFBO0tBQ3ZCO0lBQ0QsT0FBTyxTQUFTLENBQUE7QUFDbEIsQ0FBQztBQUlELE1BQU0sQ0FBQyxNQUFNLGNBQWMsR0FBYyxFQUFFLENBQUE7QUFFM0MsTUFBTSxVQUFVLFNBQVMsQ0FBQyxJQUE4QjtJQUN0RCxJQUFJLEdBQUcsR0FBRyxjQUFjLENBQUE7SUFDeEIsS0FBSyxJQUFJLENBQUMsRUFBRSxFQUFFLEtBQUssQ0FBQyxJQUFJLElBQUk7UUFBRSxHQUFHLENBQUMsRUFBRSxDQUFDLEdBQUcsaUJBQWlCLENBQUMsS0FBSyxDQUFDLENBQUE7SUFDaEUsT0FBTyxHQUFHLENBQUE7QUFDWixDQUFDIn0=